import React from 'react';
import ReactDOM from 'react-dom/client';
import './reset.css';
import './index.css';
import App from './App';
import {ResizeProvider} from "./provider/ResizeProvider";
import {AppProvider} from "./provider/AppProvider";
import {MediaProvider} from "./provider/ImageProvider";
import {YandexSdkProvider} from "./provider/yandex/yandexSdk";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <MediaProvider>
        <YandexSdkProvider>
            <ResizeProvider>
                <AppProvider>
                    <App/>
                </AppProvider>
            </ResizeProvider>
        </YandexSdkProvider>
    </MediaProvider>
);
